import React from "react";
import * as Icons from "@/icons"; // Your local SVGs as image paths
import { HelpOutline as FallbackIcon } from "@mui/icons-material";

const DynamicIcon = ({ iconName, isImage = true, ...props }) => {
  const formattedName = iconName.replace(/\s+/g, "");
  const IconSrc = Icons[formattedName];

  if (!IconSrc) return <FallbackIcon {...props} />;

  // If it’s an image, use <img>. Otherwise, you can use SVG React component (if SVGR is enabled)
  return iconName === "CloudSyncSharpIcon" ? (
    <img src={IconSrc} alt={iconName} {...props} style={{ width: 24, height: 24 }} />
  ) : (
    <IconSrc {...props} />
  );
};

export default DynamicIcon;
